import { DragDropProvider } from '@dnd-kit/react';
import { isSortable, useSortable } from '@dnd-kit/react/sortable';
import classNames from 'classnames';
import { DroppableZone } from 'components/shared/DragAndDropWorkspace/TabsWorkspace/dragndrop/DroppableZone';
import { PropsWithChildren } from 'react';

type Props = Readonly<{
  enableDragAndDrop: boolean;
  moveTab: (sourceIndex: number, targetIndex: number) => void;
}>;

export function WithDragAndDrop({ children, moveTab, enableDragAndDrop }: PropsWithChildren<Props>) {
  if (!enableDragAndDrop) {
    return <>{children}</>;
  }

  return (
    <DragDropProvider
      onDragOver={() => {}}
      onDragEnd={event => {
        const { source } = event.operation;
        if (isSortable(source)) {
          moveTab(source.initialIndex, source.index);
        }
      }}
    >
      <DroppableZone
        id="secondary-quotes-tabs"
        type="tabs"
        className="flex-grow-1 d-flex flex-nowrap overflow-x-scroll no-scrollbar"
      >
        {children}
      </DroppableZone>
    </DragDropProvider>
  );
}

type DraggableProps = Readonly<{
  enableDragAndDrop: boolean;
  id: string;
  blockIndex: number;
  isActive: boolean;
}>;

export function WithDraggable({
  children,
  id,
  blockIndex,
  enableDragAndDrop,
  isActive,
}: PropsWithChildren<DraggableProps>) {
  const { ref, handleRef, isDragging } = useSortable({
    id,
    type: 'tab',
    index: blockIndex,
    disabled: !enableDragAndDrop,
  });

  return (
    <div ref={ref} id={id} className={classNames('d-flex draggable', { active: isActive || isDragging })}>
      {children}
      <div className="drag-handle d-flex align-items-center">
        <i className={'icon icon-outlined cursor-grab text-secondary fs-2'} ref={handleRef} aria-hidden="true">
          drag_indicator
        </i>
      </div>
    </div>
  );
}
